function Support() {
  return (
    <main className="page simple-page">
      <div className="simple-inner policy">
        <h1>Support</h1>
        <p>If you have questions, you may contact us at:</p>
        <p>
          <a href="mailto:within-mindful-app@outlook.com">
            within-mindful-app@outlook.com
          </a>
        </p>
      </div>
    </main>
  );
}

export default Support;
